import { render, staticRenderFns } from "./Experiment.vue?vue&type=template&id=79aaefab&scoped=true&"
import script from "./Experiment.vue?vue&type=script&lang=js&"
export * from "./Experiment.vue?vue&type=script&lang=js&"
import style0 from "./Experiment.vue?vue&type=style&index=0&id=79aaefab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79aaefab",
  null
  
)

export default component.exports